import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL } from '@nuxt/ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _7dfae185 = () => interopDefault(import('..\\pages\\about.vue' /* webpackChunkName: "pages/about" */))
const _c7b99cb6 = () => interopDefault(import('..\\pages\\ffm.vue' /* webpackChunkName: "pages/ffm" */))
const _8d65dff4 = () => interopDefault(import('..\\pages\\grad.vue' /* webpackChunkName: "pages/grad" */))
const _c5e47578 = () => interopDefault(import('..\\pages\\ontrack.vue' /* webpackChunkName: "pages/ontrack" */))
const _6bcf3f97 = () => interopDefault(import('..\\pages\\persistence.vue' /* webpackChunkName: "pages/persistence" */))
const _c49a876c = () => interopDefault(import('..\\pages\\index.vue' /* webpackChunkName: "pages/index" */))

// TODO: remove in Nuxt 3
const emptyFn = () => {}
const originalPush = Router.prototype.push
Router.prototype.push = function push (location, onComplete = emptyFn, onAbort) {
  return originalPush.call(this, location, onComplete, onAbort)
}

Vue.use(Router)

export const routerOptions = {
  mode: 'hash',
  base: '/extensions/college-and-career-public/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/about",
    component: _7dfae185,
    name: "about"
  }, {
    path: "/ffm",
    component: _c7b99cb6,
    name: "ffm"
  }, {
    path: "/grad",
    component: _8d65dff4,
    name: "grad"
  }, {
    path: "/ontrack",
    component: _c5e47578,
    name: "ontrack"
  }, {
    path: "/persistence",
    component: _6bcf3f97,
    name: "persistence"
  }, {
    path: "/",
    component: _c49a876c,
    name: "index"
  }],

  fallback: false
}

function decodeObj(obj) {
  for (const key in obj) {
    if (typeof obj[key] === 'string') {
      obj[key] = decodeURIComponent(obj[key])
    }
  }
}

export function createRouter () {
  const router = new Router(routerOptions)

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    const r = resolve(to, current, append)
    if (r && r.resolved && r.resolved.query) {
      decodeObj(r.resolved.query)
    }
    return r
  }

  return router
}
